import React from 'react';

import { ErrorBoundary } from '@nxte-nl/error-boundary';
import { Loader } from '@nxte-nl/loader';

import { CenterContentWrapper } from '../../components/CenterContentWrapper/CenterContentWrapper';
import {
  HeaderMenuGiftCardsTabs,
} from '../../components/HeaderMenuGiftCardsTabs/HeaderMenuGiftCardsTabs';
import { layoutHooks } from '../../hooks/layoutHooks/layoutHooks';
import { messageHooks } from '../../hooks/messageHooks/messageHooks';
import { AppDataGiftCardCategories } from '../../types/Messages';
import { GiftcardCategory } from '../../types/apiTypes';

export type GetAppDataGiftCardCategoriesResponse = {
  data: GiftcardCategory[];
};

export const HeaderMenuContainer = React.memo(() => {
  const categories = messageHooks.useSubjectState(AppDataGiftCardCategories.Categories);
  const loading = messageHooks.useSubjectState(AppDataGiftCardCategories.Loading);
  const { isDesktop } = layoutHooks.useDesktop();

  return (
    <>
      {loading ? (
        <CenterContentWrapper minHeight={'120px'}>
          <Loader />
        </CenterContentWrapper>
      ) : categories
        ? (
          <ErrorBoundary>
            <HeaderMenuGiftCardsTabs isDesktop={isDesktop} items={categories || []} />
          </ErrorBoundary>
        )
        : null
      }
    </>
  );
});

HeaderMenuContainer.displayName = 'HeaderMenuContainer';
